(function () {
    'use strict';

    angular
        .module('app')
        .controller('AppController', AppController);

    AppController.$inject = ['auth', '$transitions', '$rootScope', 'helpers', 'alert',];

    function AppController(auth, $transitions, $rootScope, helpers, alert) {
        var vm = this;
        vm.title = 'Zcooly Admin';
        vm.isLoadingView = false;
        vm.logout = logout;
        vm.isLoggedIn = false;
        vm.menuIsOpen = false;

        activate();

        function activate() {

        }

        function logout() {
            if ($rootScope.confirmLeaveForm) {
                alert.confirm('confirm-leave-form')
                    .then(function () {
                        $rootScope.confirmLeaveForm = false;
                        auth.logout();
                    }, function () {});
            } else {
                auth.logout();
            }
        }

        /**
         * Global event listeners
         */
        $transitions.onStart({}, function (transition) {
            if (!auth.isLoggedIn() && 'login' !== transition.to().name) {
                return transition.router.stateService.target('login');
            }
        });

        $rootScope.$on('login', function () {
            vm.isLoggedIn = true;
        });

        $rootScope.$on('logout', function () {
            vm.isLoggedIn = false;
        });

        $rootScope.$on('toggleMobileMenu', function () {
            vm.menuIsOpen = !vm.menuIsOpen;
        });

        // Event triggered from httpErrorInterceptor.service.js
        $rootScope.$on('api-error', function (event, response) {
            helpers.handleErrorResponse(response);
        });
    }
})();